<template>
  <div class="pay-result">
    <div class="text">支付成功</div>
    <div class="btn" @click="JumpToHome">返回商家</div>
  </div>
</template>

<script>
import { getAdaPayOrderToPage } from '@/api/api'
export default {
  data () {
    return {
      gotoPageURL: ''
    }
  },
  mounted () {
    this.wxInit()
    console.log(window.location.href, '23232')
    getAdaPayOrderToPage({
      out_trade_no: this.$route.query.out_trade_no
    }).then(res => {
      console.log(res)
      if (res.code) {
        this.gotoPageURL = res.data.to_page
      }
    }).catch(() => {
      this.gotoPageURL = `'https://vip.xf-market.com/personal'`
    })
  },
  methods: {
    // 微信商家小票
    wxInit () {
      // 初始化小票
      var initData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE',
      }
      var initPostData = JSON.stringify(initData)
      parent.postMessage(initPostData, 'https://payapp.weixin.qq.com')
    },
    // 注册点击事件(去首页)
    JumpToHome () {
      let homePage = this.gotoPageURL
      var mchData = {
        action: 'jumpOut',
        jumpOutUrl: homePage, // 跳转的页面
      }
      var postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
    }
  }
}

</script>

<style lang="less" scoped>
.pay-result {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;

  .text {
    margin-bottom: 50px;
    font-weight: 600;
    font-size: 18px;
    color: #1E2020;
  }

  .btn {
    width: 120px;
    height: 48px;
    border-radius: 6px;
    background-color: #F0E1C0;
    color: #504632;
    font-size: 16px;
    text-align: center;
    line-height: 48px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payIframe.vue